'use client'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { format, parse } from 'date-fns'
import { FieldValue } from '@/types'
import { memo } from 'react'

type DateFieldProps = {
  id: string
  value: FieldValue
  isHidden: boolean
  onChangeHandler: (val: FieldValue, id: string) => void
}

const DateField = ({ id, value, isHidden, onChangeHandler }: DateFieldProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={parse(value as string, 'dd MMMM yyyy', new Date())}
        disabled={isHidden}
        onChange={(value) => {
          onChangeHandler(format(value as Date, 'dd MMMM yyyy'), id)
        }}
        format="dd MMMM yyyy"
        disableFuture
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            slotProps: {
              htmlInput: { readOnly: true },
            },
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default memo(DateField)
